import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { QRCode } from "react-qrcode-logo";

import { Button, TextField, InputAdornment, IconButton } from "@mui/material";

import BackspaceIcon from "@mui/icons-material/Backspace";

//import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import CharityElement from "./CharityElement";

import KeypadWidget_B from "./KeypadWidget_B";

import "react-phone-number-input/style.css";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal_V";

let env = require("./../../../../env");

// props has activeStep
export default function CharityDonationContent({
  isNotMobile = false,
  //changeDrawerMode,
  setSelectedCharity
  //confirmCharity
}) {
  const {} = useContext(KioskContext);

  const { qrCode, getKioskTheme } = useContext(SocketIOContext);

  const [textCharityId, setTextCharityId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const kiosktheme = getKioskTheme();
  const kioskstyles = useKioskVerticalStyles();

  const numberbuttonpress = event => {
    setTextCharityId(textCharityId + event.target.innerText);
  };

  const backspacepress = event => {
    if (textCharityId.length > 0) {
      setTextCharityId(textCharityId.substring(0, textCharityId.length - 1));
    }
  };

  const clearpress = () => {
    setTextCharityId("");
  };

  const donepress = () => {
    //setErrorMessage("Unable to find charity. Please verify ID.");
    //OR
    setSelectedCharity({
      imgPath: "",
      Title: "Title",
      Description: "Description",
      CharityId: 5
    });
  };

  return (
    <>
      {/* <div
        class="ks_flexPanelLayoutB_TopContainer"
        style={kioskstyles.flexPanelLayoutB_TopContainer}
      >
        <SubtitleWrapper isNotMobile={isNotMobile}>
          <div style={kioskstyles.charities.charityModalTextColor}>
            <Translate value="application.theme.charitySearchCharity" />
          </div>
        </SubtitleWrapper>
      </div> */}
      <div
        class=""
        style={{
          // ...kioskstyles.flexPanelLayoutB_MidContainer,
          // flexDirection: "column",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          height: "70vh"
        }}
      >
        <div
          style={{
            ...kioskstyles.charities.selectInstruction,
            ...kioskstyles.charities.charityModalTextColor,
            marginTop: "5vh",
            width: "90vw"
          }}
        >
          {/* <Translate value="application.theme.charitySearchCharityInstruction" /> */}
        </div>
        <div
          style={{
            //height: "inherit"
            //height: "45vh"
            marginTop: "3vh",
            height: "100%"
          }}
        >
          <center>
            <TextField
              id="KioskKey"
              label=""
              type="text"
              value={textCharityId}
              // style={{
              //   marginBottom: "3vh"
              // }}
              sx={{
                marginBottom: "3vh",
                "& .MuiInputBase-root": {
                  height: "7vh", // Change this value
                  width: "38vh",
                  fontSize: "4vh"
                  //textAlign: "center"
                },
                "& .MuiInputBase-input": {
                  textAlign: "center"
                }
              }}
              onChange={event => {
                let newText = event.target.value;
                newText = newText.toUpperCase().trim();
                setTextCharityId(newText);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        backspacepress();
                      }}
                      edge="end"
                    >
                      <BackspaceIcon style={{ fontSize: "3.8vh" }} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </center>

          <KeypadWidget_B
            filloutStyle={{ height: "" }}
            buttonRowStyle={{
              marginBottom: "0.4vh",
              display: "flex",
              justifyContent: "center",
              gap: "1vh"
            }}
            errorMessageStyle={{
              color: "red",
              //marginTop: "clamp(0px, 12vw, 24px)",
              fontSize: "clamp(6px, 1.6vw, 26px)",
              //position: "absolute",
              //height: "0px"
              //right: "8vw"
              // width: "100%",
              // maxWidth: "800px",
              // marginRight: "auto"
              width: "100%",
              //height: "clamp(12px, 1.6vw, 26px)"
              height: "clamp(6px, 2vw, 26px)"
            }}
            iconStyle={{ fontSize: "6vh" }}
            errorMessage={errorMessage}
            numberbuttonpress={numberbuttonpress}
            clearbuttonpress={clearpress}
            keypadDone={donepress}
            loading={loading}
          />
        </div>
        <PrinterConnectionModal />
      </div>
      {/* <div
        style={{
          ...kioskstyles.flexPanelLayoutB_BotContainer,
          //position: "fixed",
          bottom: "10.5vh"
        }}
      >
        <Button fullWidth variant="contained">
          <Translate value="application.theme.charityFindById" />
        </Button>
      </div> */}
    </>
  );
}
